import React, { useContext } from 'react';
import { ToastContainer } from 'react-toastify';
import { GlobalContext } from '../../context/GlobalContext';

function Password() {
    const { state, handlers } = useContext(GlobalContext);
    const { passwordInput } = state;
    const { handleChangePassword, handleChangePasswordInput } = handlers;

    return (
        <>
            <form onSubmit={handleChangePassword}>
                <div className='w-2/3 h-42 bg-white rounded-xl shadow-lg p-10 ml-10'>
                    <div className="flex flex-col gap-y-7">
                        <div>
                            <label htmlFor="current-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Current Password</label>
                            <input onChange={handleChangePasswordInput} value={passwordInput.current_password} name={'current_password'} type="password" id="current-password" className="bg-gray-50 border tracking-widest border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-sky-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500" />
                        </div>

                        <div>
                            <label htmlFor="new-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">New Password</label>
                            <input onChange={handleChangePasswordInput} value={passwordInput.new_password} name={'new_password'} type="password" id="new-password" minLength={8} className="bg-gray-50 border tracking-widest border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500" required />
                        </div>

                        <div>
                            <label htmlFor="confirm-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Confirm New Password</label>
                            <input onChange={handleChangePasswordInput} value={passwordInput.confirm_password} name={'confirm_password'} type="password" id="confirm-password" minLength={8} className="bg-gray-50 border tracking-widest border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500" required />
                        </div>

                        <button type="submit" className="text-white w-fit bg-sky-500 hover:bg-sky-600 focus:ring-4 focus:ring-sky-300 font-medium rounded-lg text-sm px-5 py-2.5 mt-5 mb-2 dark:bg-sky-600 dark:hover:bg-sky-700 focus:outline-none dark:focus:ring-sky-800">Change Password</button>
                    </div>
                </div>
            </form>
            <ToastContainer />
        </>
    );
}

export default Password;